module.exports = Object.freeze({
    SUCCESS : "SUCCESS",
    //NOT_FOUND: "NOT_FOUND",
    UNAUTHORIZED: "UNAUTHORIZED",
    INVALID_SESSION: "INVALID_SESSION",
    USER_LOCKED: "USER_LOCKED",
    INVALID_CHANGE_PASSWORD_SESSION: "INVALID_CHANGE_PASSWORD_SESSION",
    ALREADY_EXISTS: "ALREADY_EXISTS",
    //BUSINESS_RULE_FAILED: "BUSINESS_RULE_FAILED",
    //DATA_STORAGE_ERROR: "DATA_STORAGE_ERROR",
    INVALID_PASSWORD_TOO_SHORT: "INVALID_PASSWORD_TOO_SHORT",
    INVALID_PASSWORD_COMMON_WORD: "INVALID_PASSWORD_COMMON_WORD",
    INVALID_PASSWORD_DUP_OR_SEQ: "INVALID_PASSWORD_DUP_OR_SEQ",
});



// WEBPACK FOOTER //
// ./client/app/_helpers/apiStatus.js